import React from 'react';

export const MusicSlideOverContext = React.createContext({
    music: {},
    setMusic: () => {
    }
});
